import { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../../apiConfig";
import { Player } from "../../interfaces/Team";

type PlayersByMatchApiResponse = {
  home_players: Player[];
  away_players: Player[];
};

export function usePlayersByMatch(matchId: number) {
  const [homePlayers, setHomePlayers] = useState<Player[]>([]);
  const [awayPlayers, setAwayPlayers] = useState<Player[]>([]);

  useEffect(() => {
    const fetchPlayers = async () => {
      if (!matchId || matchId <= 0) return
      try {
        const res = await fetch(API_ENDPOINTS.playersByMatchId(matchId));
        if (res.ok) {
          let homeAndAwayPlayers: PlayersByMatchApiResponse = await res.json();
          setHomePlayers(homeAndAwayPlayers.home_players || []);
          setAwayPlayers(homeAndAwayPlayers.away_players || []);
        } else {
          setHomePlayers([]);
          setAwayPlayers([]);
        }
      } catch (e) {
        setHomePlayers([]);
        setAwayPlayers([]);
      }
    };
    fetchPlayers();
  }, [matchId]);

  return { homePlayers, awayPlayers, setHomePlayers, setAwayPlayers };
}
